var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"img"}),_c('div',{staticClass:"btn",on:{"click":function($event){return _vm.copyQQ()}}},[_vm._v("复制管理员QQ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }